var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"frame",staticClass:"phone-frame",style:({ height: `${_vm.SCREEN_HEIGHT * _vm.scale}px` })},[_c('div',{class:['phone-frame__screen', { 'phone-frame__screen--bordered': _vm.bordered }],style:({ transform: `scale(${_vm.scale})` })},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }